up.compiler('[up-disable]', (element) => {
  var targets = document.querySelectorAll(element.getAttribute('up-disable'));
  var current_state = element.checked;

  targets.forEach((target) => {
    up_toggle_all(target, current_state)
  })

  element.addEventListener('change', (event) => {
    current_state = element.checked;
    targets.forEach((target) => {
      up_toggle_all(target, current_state)
    })
  })
})

function up_toggle_all(target, current_state) {
  if (target.tagName === 'INPUT') {
    if (current_state) {
      up_enable(target);
    } else {
      up_disable(target);
    }
  } else {
    var inner_targets = target.querySelectorAll('input');
    inner_targets.forEach((inner_target) => {
      if (current_state) {
        up_enable(inner_target);
      } else {
        up_disable(inner_target);
      }
    });
  }
}

function up_enable(element) {  
  element.removeAttribute('disabled');
}

function up_disable(element) {  
  element.setAttribute('disabled', 'disabled');
}

up.compiler("a[up-spinner], button[up-spinner], input[up-spinner]", (element) => {
  let color = element.getAttribute('up-spinner') || 'primary'
  let spinner = document.createElement('div')
  spinner.className = `spinner-border text-${color}`
  spinner.setAttribute('role', 'status')

  let span = document.createElement('span')
  span.className = 'visually-hidden'
  span.innerText = 'Loading...'
  spinner.appendChild(span)

  element.addEventListener('click', (event) => {
    setTimeout(() => {
      if (element && !element.getAttribute('data-up-original-html')) {
        element.setAttribute('data-up-original-html', element.innerHTML)
      }

      const uniqueid = Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, '0');
      if (element && !element.getAttribute('data-up-spinner-id')) {
        element.setAttribute('data-up-spinner-id', uniqueid)
      }

      if(element.tagName === 'INPUT') {
        const button = document.createElement('button');
        for (const attr of element.attributes) {
          button.setAttribute(attr.name, attr.value);
        }
        button.setAttribute('data-up-original-html', element.outerHTML)
        button.appendChild(spinner);
        element.replaceWith(button);
      } else {
        element.innerHTML = ''
        element.appendChild(spinner)
      }
    }, 100);
  })
})

up.on('up:fragment:inserted', (event) => {
  const src = event.srcElement;
  if(src && src.hasAttribute('data-up-original-html')) {
    if(src.hasAttribute('data-up-original-replace')) {
      src.insertAdjacentHTML("beforebegin", src.getAttribute('data-original-html'));
      src.remove();
    } else {
      src.innerHTML = src.getAttribute('data-original-html') || 'Reload'
    }
  }
})

up.compiler('.up-on-layer-remove', (element) => {
  if(up.layer.count > 1) {
    element.remove();
  }
})

up.compiler('[up-dismiss-after]', (element) => {
  const delay = parseInt(element.getAttribute('up-dismiss-after')) || 0;
  element.addEventListener('click', (event) => {
    setTimeout(() => {
      up.layer.accept(null, { animation: 'move-to-bottom' })
    }, delay);
  });
});

up.compiler('.show-in-layer', (element) => {
  const options = {content: element, origin: element.parentElement}
  for (var attr of element.attributes) {
    if (attr.name.startsWith('up-')) {
      options[attr.name.replace('up-', '')] = attr.value;
    }
  };
  up.layer.open(options);
});
